import React, { Component } from 'react';
import { withRouter } from "react-router-dom";
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

import AccountLoginForm from "./account-login-form";

import { loadUserProfile } from '../../model/profile/actions';
import { loginUsingLocalAccount } from "../../services";
import AnonymousFormLayout from "../../layout/anonymous-form-layout";

class AccountLogin extends Component {
  state = {
    redirectUrl: undefined,
    error: undefined
  };

  componentDidMount() {
    // Manage any deep links => If user attempts to view a restricted container
    // and ends up in login, store the container they are trying to view and
    // use it later when user has logged in.
    if (this.props.location.state) {
      this.setState({
        ...this.state,
        redirectUrl: this.props.location.state.referrer
      });
    }

    this.props.loadUserProfile();
  }

  performLocalAccountLoginCallback = (formData, setSubmitting) => {
    const onSuccess = (response, body) => {
      if (response.status === 200) {
        // Move to my personal view
        this.props.loadUserProfile();
      } else if (response.status === 403) {
        setSubmitting(false);
        this.setState({
          ...this.state,
          error : "Ο λογαριασμός δε βρέθηκε."
        });
      }
    };

    const onFail = (errorType, status) => {
      setSubmitting(false);

      this.setState({
        ...this.state,
        error : "Απέτυχε η είσοδος σας για τεχνικούς λόγους."
      });
    };

    loginUsingLocalAccount(formData, onSuccess, onFail);
  };

  render() {
    if (this.props.profile.profileId !== undefined) {
      // Check if the user had attempted to access a restricted container
      // earlier. If they did, redirect current flow to the container initially
      // requested. Otherwise use the default flow (my personal view).
      let redirectUrl = '/me';
      if (this.state.redirectUrl !== undefined) {
        redirectUrl = this.state.redirectUrl;
        if (redirectUrl.startsWith('/dashboard/')) {
          redirectUrl = redirectUrl.substring(10);
        }
      }

      return (<Redirect to={redirectUrl}/>)
    } else {
      return (
        <AnonymousFormLayout backgroundImageStyle="bg-register-image">
          <AccountLoginForm error={this.state.error} onFormSubmit={this.performLocalAccountLoginCallback}/>
        </AnonymousFormLayout>
      );
    }
  }
}

const mapStateToProps = (state) => {
  return {
    profile: state.profile
  }
};

export default withRouter(connect(mapStateToProps, { loadUserProfile })(AccountLogin))